import Roles from "./assignments/Roles";


export default function Assignments() {
  return <Roles />;
}